import { ClientOnly } from "remix-utils/client-only";

export function Markdown({ text }: { text: string }) {
  return (
    <ClientOnly fallback={<div className="prose" data-component="Markdown" />}>
      {() => (
        <div
          className="prose"
          dangerouslySetInnerHTML={{ __html: text }}
          data-component="Markdown"
          onClick={(e) => {
            if (e.target instanceof HTMLElement && e.target.tagName === "A") {
              e.stopPropagation();
            }
          }}
          // Tailwind's text-inherit sets the color, not the size
          style={{ fontSize: "inherit" }}
        />
      )}
    </ClientOnly>
  );
}
